import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { IMPOUND_TYPES_ACTION_TYPE } from 'store/system/actions';

const initialState = {};

const impoundTypesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case IMPOUND_TYPES_ACTION_TYPE.GET_IMPOUND_TYPES:
        return payload || initialState;

      case IMPOUND_TYPES_ACTION_TYPE.CREATE_IMPOUND_TYPE:
      case IMPOUND_TYPES_ACTION_TYPE.EDIT_IMPOUND_TYPE:
        draft[payload.impoundTypeId] = payload;
        break;

      case IMPOUND_TYPES_ACTION_TYPE.DELETE_IMPOUND_TYPE:
        delete draft[meta.impoundTypeId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default impoundTypesReducer;
